import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {ATTRIBUTE_MULTIPLE_VALUE_TYPES} from '@netx/core-attribute/constants';
import {attributesStore} from '@netx/core-attribute/store/attributesStore';
import {SearchType} from '@netx/core-search-rules/rules/constants';
import {SavedSearchBean, SavedSearchId} from '../types';

/**
 * `getSearch` request params
 * (what is used to send to server)
 */
export interface GetSearchRequestOptions {
	id: SavedSearchId;
}

/**
 * `getSearch` request
 * (what gets sent to the server)
 */
export type GetSearchRequest = [GetSearchRequestOptions['id']];

/**
 * `getSearch` response
 * (what comes back from the server)
 */
export type GetSearchResponse = SuccessResponse<GetSearchResult>;

/**
 * `getSearch` result
 * (what is utilized from the server response)
 */
export type GetSearchResult = SavedSearchBean;

export const getSearchEndpoint = 'getSearch';

/**
 * Autolist users
 * @param fetchParams Fetch params
 */
export const getSearch = async ({id}: GetSearchRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: GetSearchRequest = [id];

	return client
		.post<GetSearchResponse>(getSearchEndpoint, requestParams)
		.then((response) => {
			const {result} = response.data;
			return {
				...result,
				criteria: result.criteria.map((criteria) => {
					let value1 = criteria.value1;
					switch (criteria.type) {
						case SearchType.METADATA: {
							const attr = attributesStore.getAttributeByName(criteria.value2);
							if (attr && ATTRIBUTE_MULTIPLE_VALUE_TYPES.includes(attr.type)) {
								value1 =
									criteria.value1 !== '' && criteria.value1.match(/.*",".*$/)
										? // the server is failing to maintain the proper escaping for a csv string
										  // this is for older saved searches
										  `\"${criteria.value1}\"`
										: criteria.value1;
							}
							break;
						}
					}

					return {
						...criteria,
						value1,
					};
				}),
			};
		});
};
export default getSearch;
